import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from '@Images/logo-white-2026.svg';

const staticClass = 'coming-soon-page';

/** 功能尚未開放公告頁，LINE OA 選單未開放的格子都連到這裡（免登入）。 */
const ComingSoonPage = () => (
    <div className={`${staticClass}-root`}>
        <div className={`${staticClass}-center`}>
            <img className={`${staticClass}-logo`} src={BrandLogo} alt="Curves" />
            <h1 className={`${staticClass}-title`}>目前功能尚未開放</h1>
            {/* 導 `/` 才會依 logonType 分流，直接指會員頁教練會跑錯 */}
            <Link className={`${staticClass}-btn`} to="/">
                前往會員專區
            </Link>
        </div>
    </div>
);

export default ComingSoonPage;
